<template>
  <div class="cure">
    <v-tabs
      hide-slider
      vertical
      class="cure__tabs"
      @change="changeCure"
      v-model="selectedCure"
    >
      <div class="cure__tabs-wrap">
        <v-tab
          v-for="cure in cureList"
          :key="cure?.id"
          class="cure__tabs-tab"
          active-class="active"
        >
          <div class="left__block item">
            <div class="img">
              <img v-if="cure?.icon" :src="cure?.icon" :alt="cure?.title">
            </div>
            <p class="price">{{cure?.fullPrice}}</p>
          </div>

          <div class="right__block item">
            <h5 class="right__block-title">{{cure?.title}}</h5>
            <p class="right__block-desc">{{cure?.description}}</p>
          </div>
        </v-tab>
      </div>

      <v-tab-item
        v-for="cure in cureList"
        :key="cure?.id"
        class="cure__items"
      >
        <div class="cure__items-img" v-if="cure?.images?.length > 0">
          <img :src="cure?.images[0]?.src" :alt="cure?.images[0]?.title">
        </div>

        <h4 class="cure__items-title">
          <a :href="cure?.detail_url" target="_blank" v-if="cure?.detail_url">{{cure?.title}}</a>
          <span v-else>{{cure?.title}}</span>
        </h4>

        <p class="cure__items-desc">{{cure?.full_description}}</p>

        <h6 class="cure__items-indications" v-if="cure?.indications?.length > 0">Показания к прохождению курса</h6>
        <ul class="cure__items-indications-list" v-if="cure?.indications?.length > 0">
          <li
            v-for="(indication, index) in cure?.indications"
            :key="index"
          >
            {{indication}}
          </li>
        </ul>

        <h6 class="cure__items-components" v-if="cure?.components?.length > 0">Основные компоненты лечебного курса</h6>
        <ul class="cure__items-components-list" v-if="cure?.components?.length > 0">
          <li
            v-for="(component, index) in cure?.components"
            :key="index"
          >
            {{component}}
          </li>
        </ul>

        <div class="cure__items-detail" v-if="cure?.detail_url">
          <a :href="cure?.detail_url" target="_blank">Смотреть подробнее</a>
        </div>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: "CureSelection",
  props: ['nutritionId', 'cureId', 'guestId'],
  data: () => ({
    selectedCure: null,

    customNutritionId: 2,
    weightCorrectionCureId: 30,
    weightCorrectionFullCureId: 32,
    // spaCureId: 3,

    mounted: false
  }),

  mounted() {
    this.mounted = true
    this.setState()
  },
  methods: {
    setState() {
      if(!(+this.cureId >= 0)) return

      let selectedIndexCure = this.cureList.findIndex(item => +item?.id === +this.cureId)

      this.selectedCure = Number.isInteger(selectedIndexCure) ? selectedIndexCure : null
    },
    changeCure(e) {
      if(!Number.isInteger(e) || +e < 0 || !this.mounted) return

      let selectCureId = this.cureList[e]?.id

      if(+selectCureId < 0) return

      this.$emit('change', selectCureId)
    },
    setCureFullPrice(cure, daysCnt) {
      const localeOptions = {style: 'currency', currency: 'RUB', minimumFractionDigits: 0}

      return cure?.map(item => {
        let price = 0,
            guestsList = !(+this.guestId > 0) ? this.$store.getters["guestsModule/getGuestsList"] :
              this.$store.getters["guestsModule/getGuestsList"].filter(item => +item?.id === +this.guestId)

        guestsList.forEach((guest) => {
          if(+guest?.guestType === 0) price += item?.priceExtension?.adults * +daysCnt
          else if(+guest?.guestType === 1) price += item?.priceExtension?.child * +daysCnt
        })

        item.fullPrice = price?.toLocaleString('ru', localeOptions)

        return item
      })
    },
    getAge(guestId) {
      let birthday = this.getGuestField(guestId, 'birthday');
      let today = new Date();
      let birthdayObj = new Date(birthday);
      let age = today.getFullYear() - birthdayObj.getFullYear();
      if (today.getMonth() < birthdayObj.getMonth() || (today.getMonth() == birthdayObj.getMonth() && today.getDate() < birthdayObj.getDay())) {
        age--;
      }
      return age
    }
  },
  computed: {
    ...mapState({
      selectedCategoryId: store => store.selection.selectedCategoryId,
      dictionary: state => state.dictionaries,
      isSpaTour: state=> state.selection.isSpaTour,
    }),

    ...mapGetters({
      getRoomCategoryById: `dictionaries/getRoomCategoryById`,
      getCureList: `dictionaries/getCureList`,
      getHealthTour: `dictionaries/getHealthTour`,
      getGuestField: 'guestsModule/getGuestField',
    }),

    selectedCategoryData() {
      return this.getRoomCategoryById(this.selectedCategoryId)
    },

    cureList() {
      const guestType = this.getGuestField(this.guestId, 'guestType')
      const guestAge = this.getAge(this.guestId)
      const availableForKids = [`1`, `3`, `21`, `32`, `33`]
      const unavilableForAdult = [`21`]
      const availableForRetiree = [`3`, `35`, `2`,`36`,`33`]

      let cureHealthBxId = this.getHealthTour.kluchiBxId;

      if(+this.selectedCategoryData.divisionId === 2) {
        cureHealthBxId = this.getHealthTour.krYarBxId
      }

      if(cureHealthBxId) {
        availableForKids.push(String(cureHealthBxId))
      }

      let daysCnt = +this.$store.state?.selection?.daysCnt
      let res = daysCnt > 0 ? this.setCureFullPrice(this.getCureList, daysCnt) : list
      if (guestType === `1`) {
        return res.filter(i => availableForKids.findIndex(y => i.btrId === y) !== -1)
      } else if (guestAge > 69 && daysCnt > 9) {
        return res.filter(i => availableForRetiree.findIndex(y => i.btrId === y) !== -1)
      } else {
        return res.filter(i => unavilableForAdult.findIndex(y => i.btrId === y) === -1)
      }
    }
  }
}
</script>

<style lang="sass">
  .cure
    &__tabs
      height: 40vh

      &-wrap
        overflow-y: auto
        overflow-x: hidden
        padding: 4px 6px 4px 4px

      &-tab
        border: 2px solid transparent
        margin-bottom: 10px
        text-transform: none
        justify-content: space-between
        padding: 0
        height: auto !important
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.25)

        &.active
          border-color: #248983
          background: #ECFAFB
          box-shadow: none

        .item
          display: flex
          flex-direction: column
          justify-content: space-between
          padding: 14px 22px 17px

          p
            margin-bottom: 5px
            white-space: break-spaces
            overflow: hidden

        .left__block
          .img
            width: 46px
            height: 46px
            margin-bottom: 10px

            img
              width: 100%
              height: 100%

          .price
            font-weight: 900
            font-size: 0.90em
            color: #696D74
            display: none

        .right__block
          flex-grow: 1
          text-align: left
          height: 90px
          font-weight: 400
          padding-left: 0
          letter-spacing: 0

          &-title
            font-size: 1em
            line-height: 1.4em
            color: #1A4745
            white-space: break-spaces
            margin: 0 !important

          &-desc
            font-size: 0.85em
            color: #696D74

    &__items
      background: #ECFAFB
      margin-left: 8px
      padding: 0.5vw 1.5vw 3.5vw
      font-weight: 400
      font-size: 1em
      color: #696D74

      &-img
        float: right
        max-width: 40%

        img
          max-width: 100%
          border-radius: 20px

      &-title
        font-weight: 700
        font-size: 1.15em
        color: #1A4745
        margin-top: 0 !important
        margin-bottom: 0 !important

        a
          color: #1A4745 !important
          text-decoration: none

      &-desc
        margin: 20px 0

      &-indications
        font-weight: 900
        font-size: 1em
        margin-bottom: 17px

        &-list li
          list-style-type: inherit !important

      &-components
        margin: 20px 0 17px
        font-weight: 900
        font-size: 1em

        &-list li
          list-style-type: inherit !important

      &-detail
        margin-top: 30px
        display: none

        a
          color: #1A4745 !important

    .v-tabs-items
      height: inherit !important

    .v-window__container
      overflow: hidden auto !important
</style>
